const state = {
    isCollapse: false,
}

export default state